import React                   from 'react'
import { connect }             from 'react-redux'
import i18n from '../../../i18n';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {mapDispatchToProps} from "../../mapDispatchToProps"
import Formsy from 'formsy-react';
import Input from '../../forms/Input'
import withBaseComponent from '../../withBaseComponent';

class EditName extends withBaseComponent(React.Component) {
  constructor(props) {
    super(props);

    this.state = {

    };

    this.onSubmit = this.onSubmit.bind(this)
  }

  onSubmit(model) {
    if (this.hasError())
      return

    model["display_name"] = !model["display_name"] ? this.props.account.service.name : model["display_name"]
    this.props.accountActions.accountUpdate(this.props.account.id, model).then(res => {
      this.toggleModal()
      this.props.toggle && this.props.toggle()
      return res
    })
  }

  accountName() {
    let {display_name, service} = this.props.account

    if(!display_name)
      display_name = service && service.name

    return display_name && display_name.substring(0, 50)
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} className={this.props.className} centered={true}>
        <Formsy ref="form" onInvalidSubmit={this.showErrors} onSubmit={this.onSubmit} onValid={this.enableButton} onInvalid={this.disableButton}>
          <ModalHeader toggle={this.props.toggle}>{i18n.t('bank.settings.edit_name')}</ModalHeader>
          <ModalBody>
            <div className="form-group">
              <label>{i18n.t('bank.form.name')}</label>
              <Input name="display_name" id="frm-name"
                value={this.accountName()}
                validations="maxLength:50"
                validationError={i18n.t('validations.accounts.maxLength', {length: 50})}
                />
            </div>
          </ModalBody>
          <ModalFooter>
            <Button onClick={this.props.toggle} className="btn mfc-btn-gray medium">{i18n.t('common.cancel')}</Button>
            <button className="btn mfc-btn-blue medium" type="submit">
              {i18n.t('common.save')}
            </button>
          </ModalFooter>
        </Formsy>
      </Modal>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(EditName)
